import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { trackEvent } from '../../../lib/analytics';

import {
    toggleSupport,
} from '../../../redux/main/main.actions';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';
import ModalWorkspaceMenu from '../../../components/Modals/ModalWorkspaceMenu/ModalWorkspaceMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import ModalFeedback from '../../../components/Modals/ModalFeedback/ModalFeedback';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';

import '../MainApp.scss';
import './Integrations.scss';

const Integrations = () => {
    document.title = 'Integrations - DB Design';

    useEffect(() => {
        document.title = 'Integrations - DB Design';
    }, []);

    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = () => {
        trackEvent('app_integrations_click_request', {
            page: 'app',
            type: 'integrations',
        });
        dispatch(toggleSupport('integration', 'main'));
    };

    return (
        <div className="dash-container integrations-page">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />
                <ModalWorkspaceMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}
                <ModalFeedback />

                <Header title='Integrations'>
                    {/* <button className='dash-main-header-button prime' onClick={(e) => { handleClick(e); }}>Request Integration</button> */}
                </Header>


                <div className="elements-group">
                    <button className="element" onClick={(e) => { handleClick(e); }}>
                        <div className="element-title">Third-party integrations</div>
                        <div className="element-description">We're actively working on expanding our integration capabilities and would love to hear your thoughts</div>
                        <div className="element-button">Request</div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Integrations;
